const tableTitleUser = {
  title: 'Usuários',
  placeholder: 'Pesquisar'
};

export default tableTitleUser;
